import React from "react"
import styled from "styled-components"
import {
  WHITE_PAPERS,
  USE_CASES,
  EDUCATIONAL_PAPERS,
} from "../../../data/resource-items"
import { ResourceItem } from "../../../components/sections/resources-list/resource-item"
import { importAll } from "../../../utils/image-utils"
import { AccentHeading } from "../../../components/common/typography/accent-heading"
import { theme } from "../../../tokens"

export const ResourcesList = () => {
  const resourceImages = importAll(
    require.context("../../../../assets/resources", false, /\.(png|jpe?g|svg)$/)
  )

  const ResourceSection = styled.div`
    margin-bottom: 80px;
    & {
      border-bottom: 1px solid ${theme.colors.lightGrey};
    }

    &.last {
      border: none;
    }
  `

  return (
    <>
      <ResourceSection>
        <AccentHeading>White Papers</AccentHeading>
        {WHITE_PAPERS.map(whitepaper => (
          <ResourceItem
            title={whitepaper.title}
            snippet={whitepaper.snippet}
            url={whitepaper.url}
            image={resourceImages[whitepaper.image]}
            key={whitepaper.title}
          />
        ))}
      </ResourceSection>
      <ResourceSection>
        <AccentHeading>Educational Papers</AccentHeading>
        {EDUCATIONAL_PAPERS.map(whitepaper => (
          <ResourceItem
            title={whitepaper.title}
            snippet={whitepaper.snippet}
            url={whitepaper.url}
            image={resourceImages[whitepaper.image]}
            key={whitepaper.title}
          />
        ))}
      </ResourceSection>

      <ResourceSection className="last">
        <AccentHeading>Use Cases</AccentHeading>
        {USE_CASES.map(useCase => (
          <ResourceItem
            title={useCase.title}
            snippet={useCase.snippet}
            url={useCase.url}
            image={resourceImages[useCase.image]}
            key={useCase.title}
          />
        ))}
      </ResourceSection>
    </>
  )
}
